import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

const reportTabs = [
  { path: '', labelKey: 'reports.tabs.dashboard', end: true },
  { path: 'orders', labelKey: 'reports.tabs.orders' },
  { path: 'revenue', labelKey: 'reports.tabs.revenue' },
  { path: 'deliveries', labelKey: 'reports.tabs.deliveries' },
  { path: 'delivery-time', labelKey: 'reports.tabs.deliveryTime' },
];

export default function ReportsLayout() {
  const { t } = useTranslation('common');

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-extrabold tracking-tight">{t('reports.title')}</h1>
        <p className="text-muted-foreground">{t('reports.description')}</p>
      </div>

      {/* Report tabs */}
      <nav className="flex gap-2 border-b overflow-x-auto">
        {reportTabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                'px-3 md:px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap',
                isActive
                  ? 'border-primary text-primary'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
              )
            }
          >
            {t(tab.labelKey)}
          </NavLink>
        ))}
      </nav>

      {/* Report content */}
      <Outlet />
    </div>
  );
}
